<template>
  <svg :class="svgClass" aria-hidden="true">
      <use :xlink:href="iconName" />
  </svg>
</template>
 
<script>
export default {
 name:'svgIcon',
 props:{
    data_iconName:{
        type:String,
        required:true
    },
    className:{
        type:String,
        default:''
    }
 },
 computed:{
     svgClass(){   //svg 的class
        if(this.className){
            return `svg-icon ${this.className}`;
        } else {
            return 'svg-icon'
        }
     },
     iconName(){  //svg xlink-href 指向的文件名
         return `#icon-${this.data_iconName}`;
     }
 },
 mounted () {
    this.$nextTick(()=>{
      document
        .querySelectorAll('svg title')
        .forEach(v => v.parentNode.removeChild(v)); //移除svg title
    })
  },
}
</script>
 
<style scoped>
.svg-icon{
    width: 1.0em;
    height: 1.0em;
    vertical-align: middle;
    fill: currentColor;
    overflow: hidden;
    user-select: none;
}
</style>